<template>
	<div id="mainContainer">
		<TheHeader @showModalSlidesComponent="showModalSlidesComponent" />
		<transition
			name="fade"
		>
			<RouterView
				v-if="isInitialized"
			/>
		</transition>
		<TheTabs />
		<transition
			name="slide-bottom"
		>
			<ModalSlides
				v-if="showModalSlides"
				@closeModalSlides="closeModalSlides"
				contentType="tutorial"
			/>
		</transition>
		<TheMaintenanceMode v-if="isGetProductsError" />
	</div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import Mixins from '@/mixins'
import StorageService from '@/services/storage.service'
import TheHeader from '@/components/TheHeader.vue'
import TheTabs from '@/components/TheTabs.vue'
import TheMaintenanceMode from '@/components/TheMaintenanceMode.vue'
import ModalSlides from '@/components/ModalSlides.vue'

export default {
	name: 'mainContainer',
	components: {
		TheHeader,
		TheTabs,
		ModalSlides,
		TheMaintenanceMode
	},
	mixins: [
		Mixins.api
	],
	data () {
		return {
			showModalSlides: false,
			isInitialized: false,
			isGetProductsError: false
		}
	},
	created () {
		this.getAllItems()
	},
	mounted () {
	},
	methods: {
		// dispatch
		...mapActions({
			productVuex_setProductList: 'Product/setProductsList',
			productVuex_setScannedBarcode: 'Product/setScannedBarcode'
		}),
		async getAllItems () {
			this.$store.dispatch('Utility/doshowLoading')
			try {
				const products = await this.$_apiMixin_getProducts()
				this.productVuex_setProductList(products)
				await this.restoreItems()
			} catch (error) {
				// [WIP] ここでtoastなどでエラー内容を通知
				this.isGetProductsError = true
				// eslint-disable-next-line
				console.error(error)
			} finally {
				this.$store.dispatch('Utility/dohideLoading')
				this.isInitialized = true
			}
		},
		/**
		 * 読み込んでいた商品の状態を復元
		 */
		async restoreItems () {
			const target = 'items'
			const d = await storageService.get(target)

			if (!d) return

			// 読み込んだ商品情報が有効期限内か確認
			const isExpired = this.checkExpiration()
			if (!isExpired) {
				this.productVuex_setScannedBarcode(d.scannedBarcode)
			} else {
				this.productVuex_setScannedBarcode([])
				await this.clearItems(target)
				this.showExipredMessage()
			}
		},
		/**
		 * 読み込んだ商品情報が有効期限内か確認
		 * @param {Number} scannedAt 読み込んだ商品の内容が更新された時間
		 * @return {Boolean} isExpired 有効期限切れかどうか
		 */
		checkExpiration (scannedAt) {
			const now = moment().unix()
			const diff = now - scannedAt
			const elapsedTime = moment.duration(diff, 'seconds')
			const lifeTime = 15 * 60 * 1000 // 15min
			const isExpired = elapsedTime > lifeTime
			return isExpired
		},
		/**
		 * 期限切れを通知
		 */
		showExipredMessage () {
			const message = '読み込んでいた情報の有効期限が切れました。もう一度読み込んでください。'
			this.$buefy.toast.open({
				duration: 5 * 1000,
				message: message
			})
		},
		/**
		 * 読み込んでいた商品の状態を削除
		 */
		async clearItems (target) {
			await storageService.delete(target)
		},
		showModalSlidesComponent () {
			this.showModalSlides = true
		},
		closeModalSlides () {
			this.showModalSlides = false
		}
	}
}

const storageService = new StorageService()
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"

#mainContainer
	display block
</style>
